import { CommonResponse, PlantIdRequest } from "@gtpl/shared-models/masters";
import { AllProdInvResponseModel, LotCodeDropDownResponse, LotNumberInfoResponse, ProdInvResponseModel, OperationsRegisterResponseModel, ProductionInventoryResponse, SubPlantResponseModel, LotTrackingResponse, OperationRegisterRequest, InventoryWipResponse, LotNumberReportResponseModel, WipQuantityResponseModel, LotAndOperationReq, GrnInfoReq, OperationReportingReq, PackingInfoReq, TransportChargesReq, JobReportingInfoReq, JsonObjectreq, WorkOrderLogReq } from "@gtpl/shared-models/production-management";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ProductionLogRequest } from "libs/shared-models/production-management/src/lib/production-inv/production-log.req";
import { GrnInformationDto } from "./dto/grn-information.dto";
import { LotInfoRequest } from "./dto/lot-info.request";
import { LotNumberRequest } from "./dto/lot-number.request";
import { OpInventoryRequest } from "./dto/op-inventory.request";
import { ProdInvDTO } from "./dto/prod-inv.dto";
import { salordeIdandsoItemIdReq } from "./dto/so-and-soitem-request";
import { subplantReportRequest } from "./dto/subplanthistory-request";
import { UnitRequest } from "./dto/unit.id.request";
import { ProductionInventoryService } from "./production-inventory.service";
import { ProductionLogService } from "./production-log.service";
import { BulkStockOutRequest, ReprocessProdReq, unitRequiest } from "@gtpl/shared-models/warehouse-management";
import { LotCodeRequest } from "./dto/lot-code.request";
import { ReportRequest } from "@gtpl/shared-models/sale-management";

@ApiTags('production-inventory')
@Controller('production-inventory')
export class productionInventoryController {
  constructor(
    private prodInvService: ProductionInventoryService,
    private logService: ProductionLogService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) { }

  @Post('/createGrnInventory')
  async createGrnInventory(@Body() grnData: GrnInformationDto): Promise<ProdInvResponseModel> {
    try {
      console.log(grnData);
      return await this.prodInvService.createGrnInventory(grnData);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProdInvResponseModel, error);
    }
  }

  @Post('getLotNumbers')
  async getLotNumbers(@Body() req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.prodInvService.getLotNumbers(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }

  @Post('getLotNumberInfo')
  async getLotNumberInfo(@Body() req: LotInfoRequest): Promise<LotNumberInfoResponse> {
    try {
      return await this.prodInvService.getLotNumberInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotNumberInfoResponse, error);
    }
  }

  @Post('/createProdInv')
  async createProdInv(@Body() prodInvDto: ProdInvDTO, isUpdate: boolean = false): Promise<ProdInvResponseModel> {
    try {
      return await this.prodInvService.createProdInv(prodInvDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProdInvResponseModel, error);
    }
  }

  @Post('/getAllProdInvs')
  async getAllProdInvs(): Promise<AllProdInvResponseModel> {
    try {
      return await this.prodInvService.getAllProdInvs();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllProdInvResponseModel, error);
    }
  }

  @Post('/getNoOfAvailableBoxes')
  async getNoOfAvailableBoxes(@Body() req: LotNumberRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getNoOfAvailableBoxes(req.operation, req.plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Post('/getQtyToBeProcessed')
  async getQtyToBeProcessed(@Body() req: LotNumberRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getQtyToBeProcessed(req.operation, req.plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getInventoryQty')
  async getInventoryQty(@Body() req: LotNumberRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getInventoryQty(req.operation, req.plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getAllOperationReports')
  async getAllOperationReports(@Body() req?: OperationRegisterRequest): Promise<OperationsRegisterResponseModel> {
    try {
      return await this.logService.getAllOperationReports(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(OperationsRegisterResponseModel, error);
    }
  }

  /**
  * 
  * @param req 
  * @returns all in progress jobs
  */
  @Post('/getAllExternalPlantLots')
  async getAllExternalPlantLots(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.logService.getAllExternalPlantLots(req.unitId)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSubPlantHistoryReportDetails')
  async getSubPlantHistoryReportDetails(@Body() req?: subplantReportRequest): Promise<SubPlantResponseModel> {
    try {
      return await this.prodInvService.getSubPlantHistoryReportDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SubPlantResponseModel, error);
    }
  }
  @Post('/getAllRejections')
  async getAllRejections(@Body() req:UnitRequest): Promise<ProductionInventoryResponse> {
    try {
      return await this.prodInvService.getAllRejections(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionInventoryResponse, error);
    }
  }
  @Post('/assignRejectionToSo')
  async assignRejectionToSo(@Body() req?: ProdInvDTO): Promise<ProductionInventoryResponse> {
    try {
      return await this.prodInvService.assignRejectionToSo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionInventoryResponse, error);
    }
  }

  @Post('/getLotTrackingReportDetails')
  async getLotTrackingReportDetails(@Body() req: LotInfoRequest): Promise<LotTrackingResponse> {
    try {
      return await this.prodInvService.getLotTrackingReportDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotTrackingResponse, error);
    }
  }
  
  // @Post('/getLotTrackingReport')
  // async getLotTrackingReport(@Body() req: ProductionLogRequest): Promise<LotTrackingResponse> {
  //   try {
  //     return await this.prodInvService.getLotTrackingReport(req);
  //   } catch (error) {
  //     return this.applicationExceptionHandler.returnException(LotTrackingResponse, error);
  //   }
  // }
  @Post('/getInventoryWipQuantity')
  async getInventoryWipQuantity(): Promise<InventoryWipResponse> {
    try {
      return await this.prodInvService.getInventoryWipQuantity();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(InventoryWipResponse, error);
    }
  }

  @Post('/getProductionInventoryInfo')
  async getProductionInventoryInfo(@Body() req: OpInventoryRequest): Promise<ProductionInventoryResponse> {
    try {
      return await this.prodInvService.getInventoryInfo(req.operation, req.plantId)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionInventoryResponse, error);
    }
  }
  
  @Post('/getStockInventory')
  async getStockInventory(@Body() req: OpInventoryRequest): Promise<ProductionInventoryResponse> {
    try {
      return await this.prodInvService.getStockInventory(req.operation, req.plantId,req.batchNumbers)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionInventoryResponse, error);
    }
  }
  @Post('/getProcessedLotNumber')
  async getProcessedLotNumber(@Body() req: PlantIdRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.prodInvService.getProcessedLotNumber(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }
  @Post('/getOperationWiseLotsInfo')
  async getOperationWiseLotsInfo(@Body() req:UnitRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.prodInvService.getOperationWiseLotsInfo(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }
  @Post('/getAllSoakingAssets')
  async getAllSoakingAssets(): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getAllSoakingAssets()
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSoakingReport')
  async getSoakingReport(): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getSoakingReport()
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getWipQuantityAgainstsoandsoitem')
  async getWipQuantityAgainstsoandsoitem(@Body() req:salordeIdandsoItemIdReq): Promise<WipQuantityResponseModel> {
    try {
      return await this.prodInvService.getWipQuantityAgainstsoandsoitem(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getphysicalquantityforlotnumber')
  async getphysicalquantityforlotnumber(@Body() req:LotAndOperationReq): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getphysicalquantityforlotnumber(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getProductionLogReport')
  async getProductionLogReport(@Body() req?:ProductionLogRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getProductionLogReport(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getProductionInventoryReport')
  async getProductionInventoryReport(@Body() req?:ProductionLogRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getProductionInventoryReport(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getLotInfo')
  async getLotInfo(@Body() req?: ProductionLogRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getLotInfo(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getReadyForDeheading')
  async getReadyForDeheading(@Body() req?: unitRequiest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getReadyForDeheading(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getInventoryLots')
  async getInventoryLots(@Body() req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.prodInvService.getInventoryLots(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSaleOrdersByLot')
  async getSaleOrdersByLot(@Body() req: LotCodeRequest): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getSaleOrdersByLot(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createGrnRecordAfterReweighment')
  async createGrnRecordAfterReweighment(@Body() req: GrnInfoReq): Promise<CommonResponse> {
    try {
      return await this.prodInvService.createGrnRecordAfterReweighment(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createDeheadingReporting')
  async createDeheadingReporting(@Body() req: JsonObjectreq): Promise<CommonResponse> {
    try {
      const request = JSON.parse(req.data)
      return await this.prodInvService.createDeheadingReporting(request)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getBatchNumberDropdown')
  async getBatchNumberDropdown(@Body() req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.prodInvService.getBatchNumberDropdown(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }

  @Post('/createValueAdditionIssuing')
  async createValueAdditionIssuing(@Body() req: JsonObjectreq): Promise<CommonResponse> {
    try {
      const request = JSON.parse(req.data)
      return await this.prodInvService.createValueAdditionIssuing(request)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getProductsAgainstValAdd')
  async getProductsAgainstValAdd(): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getProductsAgainstValAdd()
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createSoakingReporting')
  async createSoakingReporting(@Body() req:OperationReportingReq): Promise<CommonResponse> {
    try {
      return await this.prodInvService.createSoakingReporting(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createNonSoakedProductsInfo')
  async createNonSoakedProductsInfo(@Body() req:OperationReportingReq): Promise<CommonResponse> {
    try {
      return await this.prodInvService.createNonSoakedProductsInfo(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createStockInInfo')
  async createStockInInfo(@Body() req:PackingInfoReq): Promise<CommonResponse> {
    try {
      return await this.prodInvService.createStockInInfo(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoackingData')
  async getSoackingData(@Body() req: ReportRequest): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getSoackingData(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getContractAgainstDeheadingRate')
  async getContractAgainstDeheadingRate(@Body() req: OperationReportingReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getContractAgainstDeheadingRate(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

    @Post('/getCountsAgainstBatchNumber')
  async getCountsAgainstBatchNumber(@Body() req: LotAndOperationReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getCountsAgainstBatchNumber(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }
  @Post('/getTransportationChargesForReport')
  async getTransportationChargesForReport(@Body() req?: TransportChargesReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getTransportationChargesForReport(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }
  @Post('/getAllContractors')
  async getAllContractors(): Promise<CommonResponse> {
    try {
      return await this.prodInvService.getAllContractors()
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getQtyAgainstBatchAndCount')
  async getQtyAgainstBatchAndCount(@Body() req: LotAndOperationReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getQtyAgainstBatchAndCount(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getBatchNumbersForStockTransfer')
  async getBatchNumbersForStockTransfer(@Body() req: OpInventoryRequest): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getBatchNumbersForStockTransfer(req.operation,req.plantId);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }


  @Post('/getWorkerWaseReport')
  async getWorkerWaseReport(@Body() req?: TransportChargesReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getWorkerWaseReport(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/GetAllVillages')
  async GetAllVillages(): Promise<CommonResponse> {
      try {
          return await this.prodInvService.GetAllVillages();
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getOperationWiseCount')
  async getOperationWiseCount(): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getOperationWiseCount();
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  // @Post('/updateWagesInfoInWorkers')
  // async updateWagesInfoInWorkers(): Promise<CommonResponse> {
  //     try {
  //         return await this.prodInvService.updateWagesInfoInWorkers();
  //     } catch (err) {
  //         return this.applicationExceptionHandler.returnException(CommonResponse, err);
  //     }
  // }

  @Post('/getProductsAgainstLotCount')
  async getProductsAgainstLotCount(@Body() req:LotAndOperationReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getProductsAgainstLotCount(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getRejectionFromProducts')
  async getRejectionFromProducts(@Body() req:LotAndOperationReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getRejectionFromProducts(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  
  @Post('/getSoakingOutProducts')
  async getSoakingOutProducts(@Body() req:LotAndOperationReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getSoakingOutProducts(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getNonSoakedProductsdata')
  async getNonSoakedProductsdata(@Body() req:JobReportingInfoReq): Promise<CommonResponse> {
    try{

      return await this.prodInvService.getNonSoakedProductsdata(req);
    } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSoakingDataForSoakingReport')
  async getSoakingDataForSoakingReport(@Body() req: ReportRequest): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getSoakingDataForSoakingReport(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/updateVAWrongEntries')
  async updateVAWrongEntries(): Promise<CommonResponse> {
      try {
          return await this.prodInvService.updateVAWrongEntries();
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }


    @Post('/createInvForWorkOrder')
  async createInvForWorkOrder(@Body() req: WorkOrderLogReq[]): Promise<CommonResponse> {
    console.log(req,"req controller")
      try {
          return await this.prodInvService.createInvForWorkOrder(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/getAllLotNumbersForStockIn')
  async getAllLotNumbersForStockIn(): Promise<CommonResponse> {
      try {
          return await this.prodInvService.getAllLotNumbersForStockIn();
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

  @Post('/createReprocessJob')
  async createReprocessJob(@Body() req:ReprocessProdReq): Promise<CommonResponse> {
      try {
          return await this.prodInvService.createReprocessJob(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

}